export const APP_CSS = /* css */ `
  /* ── Trigger: avatar circle → expanded chat bubble → close button ── */
  .lk-widget-trigger {
    position: fixed;
    bottom: var(--wg-desktop-offset-bottom);
    right: var(--wg-desktop-offset-right);
    z-index: 2147483647;
    border-radius: 100px; border: none;
    background: transparent; color: white; cursor: pointer;
    padding: 0;
    display: flex; align-items: center; gap: 0;
    font-family: 'Manrope', sans-serif;
    outline: none;
    transition: background 0.4s ease, box-shadow 0.4s ease,
                padding 0.4s cubic-bezier(0.4,0,0.2,1),
                gap 0.4s cubic-bezier(0.4,0,0.2,1),
                transform 0.15s ease;
    -webkit-appearance: none; appearance: none;
    -webkit-tap-highlight-color: transparent;
  }
  .lk-widget-trigger:hover { transform: scale(1.04); }
  .lk-widget-trigger:active { transform: scale(0.97); }
  .lk-widget-trigger:focus,
  .lk-widget-trigger:focus-visible { outline: none; }

  /* Open state: 60×60 white circle with caret-down */
  .lk-widget-trigger--open {
    width: 60px; height: 60px;
    justify-content: center;
    background: var(--wg-bg);
    color: var(--wg-fg);
    box-shadow: 0 0 4px rgba(24,39,75,0.08), 0 0 4px rgba(24,39,75,0.12);
  }
  .lk-widget-trigger--open svg { width: 22px; height: 22px; }

  /* Avatar */
  .lk-widget-trigger-avatar {
    width: 60px; height: 60px; flex-shrink: 0;
    border-radius: 50%; overflow: hidden; display: block;
    border: 2px solid white;
    box-shadow: 0 0 12px -3px rgba(24,39,75,0.08), 0 0 12px -3px rgba(24,39,75,0.08);
    transition: width 0.4s cubic-bezier(0.4,0,0.2,1),
                height 0.4s cubic-bezier(0.4,0,0.2,1),
                border-width 0.3s ease, box-shadow 0.3s ease;
  }
  .lk-widget-trigger-avatar img {
    width: 100%; height: 100%; object-fit: cover; border-radius: 50%;
  }

  /* Expandable content (text + chevron) — hidden until expanded */
  .lk-widget-trigger-content {
    display: flex; align-items: center; gap: 10px;
    max-width: 0; opacity: 0; overflow: hidden;
    transition: max-width 0.5s cubic-bezier(0.4,0,0.2,1),
                opacity 0.3s ease 0.15s;
  }
  .lk-widget-trigger-text {
    display: flex; flex-direction: column; white-space: nowrap;
  }
  .lk-widget-trigger-title {
    font-weight: 700; font-size: 16px;
    line-height: 1.125; letter-spacing: -0.32px;
    color: var(--wg-fg, #0A3228);
  }
  .lk-widget-trigger-subtitle {
    font-weight: 500; font-size: 14px;
    line-height: 1.5; letter-spacing: -0.14px;
    color: var(--wg-fg, #0A3228);
  }
  .lk-widget-trigger-chevron {
    color: var(--wg-fg, #0A3228); flex-shrink: 0;
  }

  /* Expanded chat bubble */
  .lk-widget-trigger--expanded {
    background: white;
    padding: 10px 15px 10px 10px;
    gap: 10px;
    box-shadow: 0 0 4px rgba(24,39,75,0.08), 0 0 4px rgba(24,39,75,0.12);
  }
  .lk-widget-trigger--expanded .lk-widget-trigger-avatar {
    width: 40px; height: 40px;
    border-width: 1.3px;
    box-shadow: 0 0 8px -2px rgba(24,39,75,0.08), 0 0 8px -2px rgba(24,39,75,0.08);
  }
  .lk-widget-trigger--expanded .lk-widget-trigger-content {
    max-width: 190px; opacity: 1;
  }

  /* ── Panel ── */
  .lk-widget-panel {
    position: fixed;
    bottom: calc(var(--wg-desktop-offset-bottom) + 76px);
    right: var(--wg-desktop-offset-right);
    z-index: 2147483646;
    width: 400px; max-width: calc(100vw - 40px);
    height: 700px; max-height: calc(100vh - 120px);
    border-radius: 24px; background: var(--wg-bg); color: var(--wg-fg);
    box-shadow: 0 8px 30px rgba(0,0,0,0.12);
    display: flex; flex-direction: column; overflow: hidden;
    opacity: 0; pointer-events: none;
    transform: translateY(8px) scale(0.96);
    transition: opacity 0.2s ease, transform 0.2s ease,
                width 0.3s cubic-bezier(0.4,0,0.2,1),
                height 0.3s cubic-bezier(0.4,0,0.2,1);
  }
  .lk-widget-panel--open {
    opacity: 1; pointer-events: auto; transform: translateY(0) scale(1);
  }
  .lk-widget-panel--expanded {
    width: 800px; max-width: calc(100vw - 40px);
    height: 790px; max-height: calc(100vh - 100px);
  }

  /* Zoomed-in viewport — shrink the panel so it doesn't fill the screen */
  @media (max-height: 700px) {
    .lk-widget-panel {
      height: 420px; max-height: calc(100vh - 80px);
    }
  }

  @media (max-width: 768px) {
    .lk-widget-panel {
      width: 100vw; max-width: 100vw;
      height: 100dvh; max-height: 100dvh;
      bottom: 0; right: 0;
      border-radius: 24px 24px 0 0;
      /* Snap to the keyboard, don't animate against it. The JS visual-viewport
         pin sets the panel height as the keyboard slides up; animating height
         here would lag that and make the lift feel bumpy. Keep only the
         open/close fade. */
      transition: opacity 0.2s ease, transform 0.2s ease;
    }
    .lk-widget-trigger {
      bottom: var(--wg-mobile-offset-bottom);
      right: var(--wg-mobile-offset-right);
    }
    .lk-widget-trigger--open { display: none !important; }
  }
`;
